import React, { Fragment } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { changeTheme } from '../../features/theme/theme.slice'
import { NavLink, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconName } from '@fortawesome/fontawesome-svg-core'

interface ThemesProps {
    label?: string
    altLabel?: string
    type: 'button' | 'link' | 'switch'
    size?: 'sm' | 'lg'
    align?: 'left' | 'right'
    icon?: string
    altIcon?: string
    altThemeName: string
}

const Themes: React.FC<ThemesProps> = (props) => {
    const { label, altLabel, type, align, icon, altIcon, size, altThemeName } =
        props
    const theme: string = useAppSelector((state) => state.theme.theme)
    const newTheme: string = theme === altThemeName ? '' : altThemeName
    const altTheme = theme === altThemeName
    const themeLabel = altTheme && altLabel ? altLabel : label
    const themeIcon = altTheme && altIcon ? altIcon : icon
    const dispatch = useAppDispatch()

    const switchTheme = () => {
        dispatch(changeTheme(newTheme))
    }

    return (
        <div data-testid="themes-test">
            <OverlayTrigger
                placement="bottom"
                trigger={['hover', 'focus']}
                overlay={
                    <Tooltip id="tooltip-bottom" style={{ margin: 0 }}>
                        Switch theme
                    </Tooltip>
                }
            >
                {({ ref, ...triggerHandler }) => (
                    <>
                        {type === 'button' && (
                            <Button
                                ref={ref}
                                size={size}
                                onClick={switchTheme}
                                {...triggerHandler}
                            >
                                {themeLabel}
                            </Button>
                        )}
                        {type === 'link' && (
                            <NavLink
                                ref={ref}
                                className={'nav-link'}
                                onClick={switchTheme}
                                {...triggerHandler}
                            >
                                {icon && (
                                    <FontAwesomeIcon
                                        icon={themeIcon as IconName}
                                    />
                                )}
                                {!icon && themeLabel}
                            </NavLink>
                        )}
                        {type === 'switch' && (
                            <Form.Check
                                ref={ref}
                                type="switch"
                                id="custom-switch"
                                label={themeLabel}
                                onChange={switchTheme}
                                reverse={align === 'right'}
                                checked={altTheme}
                                {...triggerHandler}
                            />
                        )}
                    </>
                )}
            </OverlayTrigger>
        </div>
    )
}

export default Themes
